import { createFileRoute } from '@tanstack/react-router';
import { UnifiedFormsLibrary } from '@/components/forms-engine/UnifiedFormsLibrary';

export const Route = createFileRoute('/_dashboard/dashboard/settings/appointment-forms/')({
  component: AppointmentFormsIndexPage,
});

function AppointmentFormsIndexPage() {
  return <UnifiedFormsLibrary />;
}
